import { createContext } from "react";

const NoteContext=new createContext();

export default NoteContext;